module.exports = __webpack_public_path__ + "static/media/page-builder-2.dfcf4094.png";